import jwt_decode from "jwt-decode";
import {
  successNotifyService,
  failureNotifyService,
} from "@/services/errors.service.js";
import store from "../store/store.js";

export function isUserLoggedIn() {
  const accessToken = localStorage.getItem("accessToken");

  if (accessToken) {
    const exp = jwt_decode(accessToken).exp;

    if (new Date(Date.now()) < new Date(exp * 1000)) {
      return true;
    }
  }

  logout();
  return false;
}

export function getAuthenticatedUser() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    return user;
  }
  return null;
}

export function getAccessToken() {
  const accessToken = localStorage.getItem("accessToken");

  if (accessToken) {
    return accessToken;
  }
  return null;
}

export function logout() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("user");
}

const randomString = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function sendMeOTPService(payload) {
  if (isUserLoggedIn()) {
    return false;
  }

  const email = payload.email;
  const firstName = payload.firstName;
  const lastName = payload.lastName;
  const password = payload.password;
  const currentThis = payload.currentThis;
  const userSource = payload.userSource;
  const userSlug =
    email.substring(0, email.indexOf("@")) + "-" + randomString(7);
  const breakMail = payload.breakMail;

  const userDetails = {
    email,
    firstName,
    lastName,
    password,
    userSource,
    slug: userSlug,
    breakMail,
  };

  currentThis.$store
    .dispatch("auth/sendMeOTP", userDetails)
    .then((data) => {
      if (data !== false) {
        const payload = {
          title: "OTP Sent",
          text: `We sent you an OTP at ${email}`,
          currentThis,
        };

        currentThis.$store.commit("auth/SET_OTP_STATUS", true);

        successNotifyService(payload);
      }
    })
    .catch((err) => {
      const payload = {
        title: "Cannot Send OTP",
        text: "We couldn't send you the OTP. Please try again later.",
        currentThis,
      };

      currentThis.$store.commit("auth/SET_OTP_STATUS", false);

      failureNotifyService(payload);

      throw err;
    });
}

export function verifyOTPService(payload) {
  if (isUserLoggedIn()) {
    return false;
  }

  const email = payload.email;
  const boardId = payload.boardId ? payload.boardId : null;
  const otp = payload.otp;
  const currentThis = payload.currentThis;
  const userSource = payload.userSource;
  const userId = payload.userId;
  const organizationSlug = payload.organizationSlug;
  const atb = payload.atb;
  const boardSlug = payload.boardSlug;
  const redirectTo = payload.redirectTo;

  const userDetails = {
    email,
    password: otp,
  };
  currentThis.$store
    .dispatch("auth/authenticateUser", userDetails)
    .then((resAuth) => {
      // // console.log("Authentication Success", resAuth);

      const payload = {
        title: "Authentication Successful",
        text: "Let's get you boarded !",
        currentThis,
      };

      successNotifyService(payload);

      currentThis.$vs.loading();

      currentThis.$store
        .dispatch("users/fetchUser", currentThis.$store.state.auth.user._id)
        .then((res) => {
          currentThis.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          currentThis.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          currentThis.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          currentThis.$store.commit("editor/SET_PROJECTS", res.data.projects);
          currentThis.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          currentThis.$store.commit(
            "editor/SET_PERSONALITY",
            res.data.personality[0]
          );

          // If addToBoard is true.
          if (atb && boardSlug) {
            // User has come from board invite link
            currentThis.$router.push({
              name: "link-board-invite",
              params: { boardSlug: boardSlug },
            });
            return;
          } else if (boardId && userSource === "boardInviteAutoLogin") {
            // User has come from auto login link
            currentThis.$router.push({
              name: "user-board",
              params: { boardId: boardId },
            });
            return;
          } else if (redirectTo && userSource === "magicLinkAutoLogin") {
            // User has come from auto login link
            // currentThis.$router.push({
            //   name: "user-board",
            //   params: { boardId: boardId },
            // });
            window.location.href = redirectTo;
            return;
          } else if (userSource === "editorAbout") {
            // If user has logged in from inside editor
            currentThis.$vs.loading.close();
            return;
          }

          if (organizationSlug === "dpd-belux") {
            currentThis.$store
              .dispatch(
                "alex/fetchDetails",
                currentThis.$store.state.auth.user._id
              )
              .then(() => {
                console.log("userSource", userSource);
                if (userSource === "loginPage") {
                  // currentThis.$router.push({name: "user-home"})
                  window.location.href = "/user/dashboard";
                }
              })
              .catch((err) => {
                throw err;
              })
              .finally(() => {
                window.location.reload();
                currentThis.$vs.loading.close();
              });
          } else if (organizationSlug === "gala") {
            currentThis.$store
              .dispatch(
                "boards/fetchUserBoardData",
                currentThis.$store.state.auth.user._id
              )
              .then(() => {
                //window.location.reload();
                if (userSource === "loginPage") {
                  // currentThis.$router.push({name: "user-home"})
                  window.location.href = "/user/dashboard";
                }
              })
              .catch((err) => {
                throw err;
              })
              .finally(() => {
               // window.location.reload();
                currentThis.$vs.loading.close();
              });
          } else if (organizationSlug === "emotionhack") {
            currentThis.$store
              .dispatch(
                "boards/fetchUserBoardData",
                currentThis.$store.state.auth.user._id
              )
              .then(() => {
                //window.location.reload();
                if (userSource === "loginPage") {
                  // currentThis.$router.push({name: "user-home"})
                  window.location.href = "/user/dashboard";
                }
              })
              .catch((err) => {
                throw err;
              })
              .finally(() => {
                window.location.reload();
                currentThis.$vs.loading.close();
              });
          } else {
            if (organizationSlug === "emotionhack") {
              window.location.reload();
            } else if (organizationSlug === "gala") {
              window.location.reload();
            } else {
              window.location.href = "/user/dashboard";
              currentThis.$vs.loading.close();
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    })
    .catch((err) => {
      const payload = {
        title: "Authentication Error",
        text: "We couldn't authenticate you. Please try again later.",
        currentThis,
      };

      failureNotifyService(payload);
      throw err;
    });
}

export async function microsoftLoginService(userObject) {
  const user = userObject.user;
  const accessToken = userObject.accessToken;

  const userDetails = {
    user,
    accessToken,
  };

  const authMicrosoftUser = await store.dispatch(
    "auth/microsoftAuth",
    userDetails
  );

  store
    .dispatch("users/fetchUser", store.state.auth.user._id)
    .then((res) => {
      store.commit(
        "editor/SET_PERSONAL_EVALUATION",
        res.data.personalEvaluation[0]
      );
      store.commit("editor/SET_CAREER_HISTORY", res.data.careerHistory);
      store.commit(
        "editor/SET_EDUCATIONAL_QUALIFICATIONS",
        res.data.educationalQualifications
      );
      store.commit("editor/SET_PROJECTS", res.data.projects);
      store.commit("editor/SET_EXTRA_CURRICULAR", res.data.extraCurricular[0]);
      store.commit("editor/SET_PERSONALITY", res.data.personality[0]);

      // // console.log(res.data.extraCurricular[0]);
      // if (currentThis.$store.state.organization.orgData.activeMarketplace) {
      store
        .dispatch("alex/fetchDetails", store.state.auth.user._id)
        .then(() => {
          // if(userSource === 'loginPage') {
          // currentThis.$router.push({name: "user-home"})
          window.location.href = "/dpd-belux/alex";
          // }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          // this.$vs.loading.close();
        });
      // }
      // else {
      //   currentThis.$vs.loading.close();
      //   if(userSource === 'loginPage') {
      //     // currentThis.$router.push({name: "user-home"})
      //     window.location.href = "/user/dashboard"
      //   }
      // }
    })
    .catch((err) => {
      throw err;
    });
}
